<template>
    <div class="list-ms">
        <div v-if="ysItem.isGd==0||ysItem.isName==0">
            <van-cell-group custom-class="goods-cell-group" :border="false">
                <van-cell icon="clock-o" :is-link="ysItem.isGd==0" @click="">
                    <div style="display: flex;flex-direction: row;justify-content:space-between;">
                        <span style="font-size: 15px" v-if="ysItem.isName==0">{{ysItem.gnName}}</span>
                        <span style="font-size: 15px" v-if="ysItem.isGd==0" @click="toMsList">更多</span>
                    </div>
                </van-cell>
            </van-cell-group>
            <div style="border-top: #EEEEEE solid 1px"></div>
        </div>
        <div v-for="item in items">
            <Style1 v-if="item.styleNum == 1" :imgMap="item.imgMap"/>
            <Style2 v-if="item.styleNum == 2" :imgMap="item.imgMap"/>
            <Style3 v-if="item.styleNum == 3" :imgMap="item.imgMap"/>
            <Style4 v-if="item.styleNum == 4" :imgMap="item.imgMap"/>
        </div>
        <div class="ms-items">
            <div class="ms-item" v-for="(item,index) in msList">
                <div>
                    <el-statistic :value="item.time" format="HH:mm:ss" time-indices>
                        <template slot="prefix">
                            <span style="font-size: 10px;line-height: 20px;">限时</span>
                        </template>
                    </el-statistic>
                </div>
                <!--                :class="{'bo-btn':msList.length-1!=index}"-->
                <div class="msitem-skuinfo" @click="toDetails(item.id)">
                    <div style="width: 100px;height: 100px">
                        <img :src="item.imgUrl" style="width: 100px;height: 100px">
                    </div>
                    <div class="msskuinfo">
                        <span style="font-size: 13px;font-weight: bold;height: 20px">{{item.msName}}</span>
                        <div class="jindu">
                            <van-progress
                                    color="#ee0a24"
                                    :percentage="item.xsbl"
                                    stroke-width="12"
                                    style="width: 60%;"
                            />
                            <span style="font-size: 10px;margin-left: 5px">已售 {{item.sale}}</span>
                        </div>
                        <div class="jgxx">
                          <div class="jgxx1">
                              <span style="font-size: 11px;color: #CCCCCC;margin-top: 8px">抢购价</span>
                              <span style="font-size: 18px;color: #ff4d51;"><span
                                      style="font-size: 10px">¥</span> {{item.spikePrice}}</span>
                              <span style="font-size: 11px;text-decoration:line-through;color: #CCCCCC">原价: {{item.spikePrice}}</span>
                          </div>
                            <div class="qianggou">
                                <span class="qianggousp">立即抢购</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";
    import Style1 from "../../common/style/style1";
    import Style2 from "../../common/style/style2";
    import Style3 from "../../common/style/style3";
    import Style4 from "../../common/style/style4";

    export default {
        components: {
            Style1,
            Style2,
            Style3,
            Style4,
        },
        data() {
            return {
                deptId: '',
                ysType: 1,
                msList: [],
                ysItem: {},
                items: [],
            };
        },
        props: {
            item: Object
        },
        async created() {
            this.ysItem = this.item
            this.deptId = getDeptId()
            this.getStyleItems()
            this.getSpmMscList()
        },

        methods: {
            async getStyleItems() {
                let data = {
                    deptId: this.deptId,
                    styleId: this.ysItem.id,
                    isShow: "0",
                }
                let res = await this.$get("/spm/getSpmStyleItems", data)
                this.items = res.list
            },
            async getSpmMscList() {
                let data = {
                    deptId: this.deptId,
                    isShow: "0",
                }
                let res = await this.$get("/spm/getSpmMscList", data)
                this.msList = res.list
            },
            toDetails(id) {
                this.$router.push('/msDetails/' + this.deptId + '/' + id)
            },
            toMsList(id) {
                this.$router.push('/msList/' + this.deptId)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .list-ms {
        margin: 0 5px 5px 5px;
    }

    .ms-items {
        display: flex;
        flex-direction: column;
        width: 95%;
        margin: auto;
    }

    .ms-item {
        display: flex;
        flex-direction: column;
        margin-top: 5px;
        margin-bottom: 10px;
    }

    .msitem-skuinfo {
        margin-top: 12px;
        display: flex;
        flex-direction: row;
    }

    .msskuinfo {
        display: flex;
        flex-direction: column;
        width: 60%;
        margin-left: 18px;
        height: 96px;
    }

    ::v-deep .el-statistic .con span {
        float: left;
        display: inline-block;
        margin: 0;
        line-height: 100%;
        font-size: 16px;
        text-align: left;
    }

    ::v-deep .el-statistic .con .number {
        font-size: 12px;
        padding: 3px 8px;
    }

    ::v-deep .el-statistic .con {
        display: flex;
        flex-direction: row;
        justify-content: left;
        color: #303133;
    }

    .bo-btn {
        border-bottom: #EEEEEE solid 1px;
    }

    ::v-deep .van-progress__pivot {
        position: absolute;
        top: 50%;
        box-sizing: border-box;
        min-width: 3.6em;
        color: #fff;
        line-height: 11px;
        text-align: center;
        word-break: keep-all;
        background-color: #1989fa;
        -webkit-transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        transform: translate(0, -50%);
        height: 11px;
    }
    .jindu{
        display: flex;
        flex-direction: row;
        height: 25px;
        align-items: center
    }
    .jgxx{
        height: 60px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .jgxx1{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .qianggou{
    }
    .qianggousp{
        display: block;
        float: right;
        font-size: 13px;
        background-color: #FE7272;
        padding: 3px 5px;
        border-radius: 15px;
        color: #ffffff;
        margin-top: 16px;
    }

</style>
